import React, { useState, useEffect } from 'react';
import { api } from '../lib/api';
import { Landmark, ThumbsUp, HelpCircle, ThumbsDown, MessageSquareText } from 'lucide-react';

const VOTE_META = {
  interested: { Icon: ThumbsUp, label: 'Interested', cls: 'text-emerald-300 border-emerald-500/40 bg-emerald-500/10' },
  questions: { Icon: HelpCircle, label: 'Questions', cls: 'text-blue-300 border-blue-500/40 bg-blue-500/10' },
  decline: { Icon: ThumbsDown, label: 'Not interested', cls: 'text-red-300 border-red-500/40 bg-red-500/10' },
};

const fmtMeeting = (s) => {
  if (!s) return '—';
  return new Date(s + 'T00:00:00').toLocaleDateString('de-DE', { weekday: 'long', day: '2-digit', month: '2-digit', year: 'numeric' });
};

export const DealACFeedback = ({ projectId }) => {
  const [meetings, setMeetings] = useState([]);

  useEffect(() => {
    api.getProjectAcFeedback(projectId)
      .then(res => setMeetings(res.data.meetings || []))
      .catch(() => {});
  }, [projectId]);

  if (meetings.length === 0) return null;

  return (
    <div className="bg-card border border-purple-500/25 rounded-sm" data-testid="deal-ac-feedback">
      <div className="px-4 py-3 border-b border-border flex items-center gap-2">
        <Landmark className="w-4 h-4 text-purple-400" />
        <p className="font-heading text-base text-foreground">AC Feedback</p>
        <span className="text-[11px] text-muted-foreground">
          {meetings.length} AC meeting{meetings.length !== 1 ? 's' : ''} — members can update their vote until each meeting day
        </span>
      </div>
      {meetings.map(m => (
        <div key={m.meeting_date} className="px-4 py-3 border-b border-border last:border-b-0" data-testid={`ac-feedback-meeting-${m.meeting_date}`}>
          <p className="text-[11px] text-purple-300 font-medium mb-2">AC-Meeting {fmtMeeting(m.meeting_date)}</p>
          <div className="space-y-2">
            {m.entries.map(e => {
              const meta = VOTE_META[e.vote] || { Icon: MessageSquareText, label: 'Comment', cls: 'text-muted-foreground border-border bg-secondary' };
              return (
                <div key={e.email} className="flex items-start gap-2 flex-wrap">
                  <span className={`inline-flex items-center gap-1 text-[10px] font-mono border rounded px-1.5 py-0.5 shrink-0 ${meta.cls}`}>
                    <meta.Icon className="w-3 h-3" /> {meta.label}
                  </span>
                  <span className="text-xs text-foreground font-mono">{e.email}</span>
                  {e.changed && <span className="text-[9px] text-amber-400 border border-amber-400/30 rounded px-1 py-0.5">updated</span>}
                  {e.updated_at && (
                    <span className="text-[10px] text-muted-foreground">
                      {new Date(e.updated_at).toLocaleDateString('de-DE')}
                    </span>
                  )}
                  {e.comment && (
                    <p className="w-full text-xs text-muted-foreground bg-secondary/40 border-l-2 border-purple-500/40 rounded-sm px-2.5 py-1.5 ml-0.5">
                      {e.comment}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};
